/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import SingleParentModal from '../modals/SingleParentModal';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ConfirmAlertWithAmount from 'modules/common/components/ConfirmAlertWithAmount';
import SingleParentContent from './SingleParentContent';


import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
  status: '',
  type: 'SOLO PARENT',
};


function SoloParentContainer({
  permissions,
  history,
  match,
  isLoading,

  showSingleParent,
  singleParentList,
  getSingleParentList,
  singleParentListPager,

  approveTransaction,
  rejectTransaction,

}) {
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {

    getSingleParentList({ type: 'SOLO PARENT' })
  };

  const param = {
    type: 'SOLO PARENT',
    q: formData.keyword,
    sort_by: 'asc',
    status: filter.status,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      status: e.value,
    });
    getSingleParentList({ ...filter, status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getSingleParentList({ type: 'SOLO PARENT', q: formData.keyword });
    } else {
      getSingleParentList({ type: 'SOLO PARENT' });
    }
  }, [debouncedSearchTerm]);

  // handle Approve button
  const handleApprove = (data) => (e) => {
    e.preventDefault();

    // const args = {
    //   status: 'APPROVED',
    //   amount: '12000',
    //   remarks: 'random test 3',
    // }
    // approveTransaction(
    //   _.get(data, 'id'),
    //   args,
    //   () => {
    //     showSingleParentList(_.get(data, 'id'));
    //     console.log('singleParentInfo', singleParentInfo)
    //   }
    // );

    ConfirmAlertWithAmount(
      'Are you sure, you want to Approve this application?',
      (remarks, amount) => {

        const args = {
          status: 'APPROVED',
          remarks,
          amount,
          type: 'SOLO PARENT',
        }
        approveTransaction(
          _.get(data, 'id'),
          args,
          () => {
            showSingleParentList(_.get(data, 'id'), {type: 'SOLO PARENT'});
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // const aprove = (data) => (e) => {
  //   e.preventDefault();
  //   const args = {
  //     status: 'APPROVED',
  //     amount: '5000.00',
  //     remarks: 'testing'
  //     // type: 'SINGLE_PARENT',
  //   }

  //   approveTransaction(
  //     _.get(data, 'id'),
  //     args,
  //     () => {
  //       showSingleParentList(_.get(data, 'id'));
  //       console.log('approveTransaction', approveTransaction(_.get(data, 'id'), args, () => { showSingleParentList(_.get(data, 'id'))}))
  //     }
  //   );
  // }

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <SingleParentModal actionType="ADD" />,
      title: 'Add Citizen',
      modalSize: 'modal-lg',
    });
  };

  // handle reject button
  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        rejectTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'REJECTED'
          },
          () => {
            showSingleParent(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const exportCSV = () => {

    const handleExportCsv = e => {
      e.preventDefault();

      const src = `${process.env.REACT_APP_WS
        }/api/v1/administrators/export/social_amelioration_citizens?bearer_token=${token}&email=${_.get(authProfile, 'email')}&type=${param.type}&q=${param.q}&output=D`;

      setTimeout(() => {
        window.location.href = src;
      }, 500);
    }

    return (
      <div className="d-flex align-items-center px-0 pt-2">
        {Acl(permissions, ['SOCIAL AMELIORATION SINGLE PARENT EXPORT CSV']) && (
          <button
            onClick={handleExportCsv}
            className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary w-100"
          >
            Export Single Parent List to CSV
          </button>
        )}
      </div>
    )
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName=""
            getData={getSingleParentList}
            setParams={param}
            setKeyword={handleOnChange}

            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'status')
            )}
            status={_.get(filter, 'status') || ''}
            keyword={_.get(formData, 'keyword') || ''}

            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            // listName="Transaction"
            label="Citizen Lists"
            // LEFT SECTION
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="senior-citizen-list">
                  {`${_.get(item, 'attributes.first_name') || ''} ${_.get(item, 'attributes.middle_name') || ''} ${_.get(item, 'attributes.last_name') || ''}`}
                </div>
                <h4 className="mt-1 mb-0 senior-citizen-list-numbers">
                  {' '}{_.get(item, 'attributes.contact_number')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            // statusFilter
            selected={params.id}
            data={singleParentList}
            dataPager={singleParentListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            // RIGHT SECTION
            renderTopContent={() => (
              <div className="w-100 d-flex px-3 pb-3">
                {Acl(permissions, ['SOCIAL AMELIORATION SINGLE PARENT ADD']) && (
                  <button
                    type="button"
                    onClick={handleAddModal}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    style={{ height: "32px" }}
                  >
                    <i className="fas fa-plus" /> &nbsp;&nbsp;
                    Add Solo Parent
                  </button>
                )}
              </div>
            )}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <SingleParentContent
                        UpdateData={UpdateData}
                        testingApprove={handleApprove}

                        onApprove={handleApprove}
                        onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.soloParentId && singleParentList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(singleParentList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            customButton={exportCSV()}
          />
        )}
      />
    </div>
  );
}

SoloParentContainer.propTypes = {
  permissions: PropTypes.instanceOf(Array).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,

  singleParentList: PropTypes.instanceOf(Object).isRequired,
  getSingleParentList: PropTypes.instanceOf(Function).isRequired,
  singleParentListPager: PropTypes.instanceOf(Object).isRequired,
  showSingleParent: PropTypes.instanceOf(Function).isRequired,

  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,

  singleParentInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  isLoading: api.loading.indexOf(c.GET_SINGLE_PARENT) > -1,

  singleParentList: _.get(api, `${c.GET_SINGLE_PARENT}.list`) || [],
  singleParentListPager: _.get(api, `${c.GET_SINGLE_PARENT}.pager`) || [],

  // individual info
  singleParentInfo: _.get(api, `${c.SHOW_SINGLE_PARENT}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SoloParentContainer);